export const buildCampaignDescription = campaign => {
  if (campaign._id === '66ff7a988c16d9ec2bd573ac') {
    return 'Bird, Brenna (State: Attorney General)';
  }
  if (
    !campaign.candidate ||
    !campaign.candidate.firstName ||
    !campaign.candidate.lastName
  ) {
    return `${campaign.campaignName} [${campaign.managedBy}]`;
  }
  if (campaign.officeType === 'Federal') {
    return `${campaign.candidate.lastName}, ${campaign.candidate.firstName} (${
      campaign.officeType
    }: ${campaign.officeName.replace(', undefined', '')}) [${campaign.managedBy}]`;
  }
  return `${campaign.candidate.lastName}, ${campaign.candidate.firstName} (${
    campaign.officeType
  }: ${campaign.officeState || ''} ${campaign.officeName.replace(
    ', undefined',
    '',
  )}) [${campaign.managedBy}]`;
};

export const transformCampaignsForSelection = item => {
  const key = item._id;
  const text = buildCampaignDescription(item);
  return {
    key,
    text,
  };
};
